//
import axios from 'axios'

//
import OfferModel from '@/models/Sale/SlOffer'
import Service from '@/services/api/service'

//
export default class extends Service {
    //
    static appends = [
        'name_product',
        'upc_code_product',
        //'sales_prices',
    ]

    //
    static includes = ['wh_product.wh_subfamily']

    //
    static model = OfferModel

    /**
     *
     */
    static async createMassive(data) {
        //
        try {
            //
            const response = await axios.post(
                process.env.VUE_APP_API_ROUTE + '/massive_create_offer',
                {
                    wh_products: data.products,
                    name: data.name,
                    g_branch_office_id: data.branchOfficeId,
                    init_datetime: data.initDateTime,
                    finish_datetime: data.finishDateTime,
                }
            )

            //
            return response.data
        } catch (error) {
            //
            error.response.data.errors = this.errors(error.response.data.errors)

            //
            return error.response.data
        }
    }

    /**
     *
     */
    static async deleteMassive(data) {
        //
        try {
            //
            const response = await axios.patch(
                process.env.VUE_APP_API_ROUTE + '/massive_delete_offer',
                {
                    sl_offers: data.offers,
                }
            )

            //
            return response.data
        } catch (error) {
            //
            error.response.data.errors = this.errors(error.response.data.errors)

            //
            return error.response.data
        }
    }

    //
    static errors(errors) {
        //
        let message = null

        //
        if (typeof errors === 'object') {
            //
            Object.values(errors).forEach(error => {
                //
                switch (typeof error) {
                    case 'object':
                        message = [String(message || ''), error.pop()]
                            .filter(Boolean)
                            .join(' ')
                        break
                    case 'string':
                        message = [String(message || ''), error.pop()]
                            .filter(Boolean)
                            .join(' ')
                        break
                }
            })
        }

        //
        message = message.replace(
            'El campo wh products es obligatorio',
            'La lista de productos es obligatoria'
        )
        message = message.replace(
            'El campo init datetime',
            'La fecha de inicio'
        )
        message = message.replace(
            'El campo finish datetime',
            'La fecha de termino'
        )
        message = message.replace(
            'El arreglo de productos',
            'La lista de productos'
        )
        message = message.replace('init datetime', 'la fecha de inicio')
        message = message.replace('finish datetime', 'la fecha de termino')
        message = message.replace('today', 'hoy')

        //
        return message.replace('El campo wh products', 'La lista de productos')
    }
}
